// We still need this barrel file to support Dato-entered icons
// (e.g. Button, ListWithIcons)
export * from 'react-feather';
export * from './ai';
export * from './svg-gradients';

//# sourceMappingURL=index.js.map